var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navbar',{attrs:{"navbar-menu-classes":"navbar-right"},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('div',{staticClass:"navbar-wrapper"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }